import { useState, useRef, useEffect } from 'react'
import { Modal, Button, Form, Alert } from 'react-bootstrap'

function PINPrompt({ show, onHide, onVerify, title = 'Enter PIN', loading = false, error = null }) {
  const [pin, setPin] = useState(['', '', '', '', ''])
  const inputRefs = [useRef(), useRef(), useRef(), useRef(), useRef()]

  useEffect(() => {
    if (show) {
      setPin(['', '', '', '', ''])
      setTimeout(() => inputRefs[0].current?.focus(), 100)
    }
  }, [show])

  const handleDigitChange = (index, value) => {
    if (!/^\d?$/.test(value)) return

    const newPin = [...pin]
    newPin[index] = value
    setPin(newPin)

    if (value && index < 4) {
      inputRefs[index + 1].current?.focus()
    }
  }

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      inputRefs[index - 1].current?.focus()
    }
  }

  const handlePaste = (e) => {
    e.preventDefault()
    const pastedData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 5)
    if (pastedData.length === 5) {
      setPin(pastedData.split(''))
      inputRefs[4].current?.focus()
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const fullPin = pin.join('')
    if (fullPin.length === 5) {
      onVerify(fullPin)
    }
  }

  const isComplete = pin.every(d => d !== '')

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="text-center">
          {error && <Alert variant="danger">{error}</Alert>}
          <p className="text-muted mb-4">Enter your 5-digit PIN to continue</p>
          <div className="d-flex justify-content-center gap-2 mb-3">
            {pin.map((digit, index) => (
              <Form.Control
                key={index}
                ref={inputRefs[index]}
                type="password"
                inputMode="numeric"
                maxLength={1}
                value={digit}
                onChange={(e) => handleDigitChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onPaste={handlePaste}
                style={{
                  width: '50px',
                  height: '60px',
                  fontSize: '24px',
                  textAlign: 'center',
                  fontWeight: 'bold'
                }}
                disabled={loading}
                autoComplete="off"
              />
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading || !isComplete}>
            {loading ? 'Verifying...' : 'Verify'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default PINPrompt
